import { every, isEmpty, isEqual } from "lodash-es"
import { Path, UseFormSetError } from "react-hook-form"
import { FormFieldError, Maybe } from "@oysterhr/schema"

export const dirty = <T extends Record<string, unknown>>(
  initial: T,
  current: T,
  fields: string[],
) => !every(fields, f => isEqual(initial[f], current[f]))

export const valueOrNull = (field: undefined | null | string): null | string => {
  return field && field !== "" ? field : null
}

export interface SelectOption {
  label: string
  code: string | null
  isLast?: true
}

export function parseNumber(value: null | undefined | string): number | undefined | null {
  if (value == null) {
    return value
  }
  return value !== "" ? +value : undefined
}

export const PHONE_NUMBER_REGEXP = /^\+\d+$/

export const handleFormErrors = <
  ErrorObject extends Record<string, unknown>,
  FormShape extends Record<string, unknown>,
>(
  objectWithErrors:
    | (ErrorObject & {
        fieldErrors?: Maybe<FormFieldError[]>
        errors?: Maybe<string[]>
      })
    | null
    | undefined,
  setError: UseFormSetError<FormShape>,
  mapKeys: (key: string) => Path<FormShape> = (key: string) => key as Path<FormShape>,
) => {
  const fieldErrors = objectWithErrors?.fieldErrors ?? []
  const errors = objectWithErrors?.errors ?? []
  const hasErrors = fieldErrors.length > 0 || errors.length > 0

  if (hasErrors) {
    for (const fieldError of fieldErrors) {
      setError(mapKeys(fieldError.fieldId), {
        message: fieldError.fullMessage || fieldError.message,
      })
    }

    if (!isEmpty(errors)) {
      setError("graphql" as Path<FormShape>, { types: { graphql: errors } })
    }
  }
  return {
    hasErrors,
  }
}
